module.exports = __webpack_public_path__ + "static/media/Jacky Bibliowicz.3aa808b8.png";